import React, { useEffect, useState } from 'react';
import A12Y_CONST from '../common/a12yConst'
import { secureClient } from '../config/axiosClient';
import MyAccountPersonalInformationComponent from './MyAccountPersonalInformationComponent'
import MyAccountPasswordComponent from './MyAccountPasswordComponent'
import LoaderFullScreenComponent from './LoaderFullScreenComponent';
import TabScrollWrapper from './TabScrollWrapper';
import Loading from "./LoadingComponent";
import ErrorMessageComponent from '../components/ErrorMessageComponent'
import SuccessMessageComponent from '../components/SuccessMessageComponent'
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import PopUpComponent from "./PopUpComponent";


import parsePhoneNumber from "libphonenumber-js";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
    useElements,
    useStripe
} from '@stripe/react-stripe-js';
import Select from 'react-select';
import PopUpNewDependentConfirmation from './PopUpNewDependentConfirmation';
import PopUpRejoinConfirmation from './PopUpRejoinConfirmation';

function MyAccountViewComponent(props) {
    const history = useHistory();
    const stripe = useStripe();
    const elements = useElements();

    const [loading, setLoading] = useState(false);
    const [popUpType, setPopUpType] = useState('');
    const [subscriptionMsg, setSubscriptionMsg] = useState('');
    const [mobileNumberFormat, setMobileNumberFormat] = useState('');
    const [alternateNumberFormat, setAlternateNumberFormat] = useState('');
    const [isPopUp2, setIsPopUp2] = useState(false);
    const [visibleSection, setVisibleSection] = useState("Overview");
    const [subscriptionQuantity, setSubscriptionQuantity] = useState(1);

    const [cardErrorMsg, setCardErrorMsg] = useState('');
    const [expiryErrorMsg, setExpiryErrorMsg] = useState('');
    const [cvcErrorMsg, setCvcErrorMsg] = useState('');
    const [isPaymentEdit, setIsPaymentEdit] = useState(false);
    const [openPaymentInEditMode, setOpenPaymentInEditMode] = useState(false);
    const [promoCodeValue, setPromoCodeValue] = useState('');
    const [isNumberComplete, setIsNumberComplete] = useState(false);
    const [isExpiryComplete, setIsExpiryComplete] = useState(false);
    const [isCVCComplete, setIsCVCComplete] = useState(false);

    const [isRejoinPopUp, setIsRejoinPopUp] = useState(false);
    const [isJoinPopup, setIsJoinPopup] = useState(false);

    useEffect(() => {
        if (openPaymentInEditMode && visibleSection === "PaymentMethod") {
            setIsPaymentEdit(true);
            setOpenPaymentInEditMode(false);
        } else {
            setIsPaymentEdit(false);
        }
    }, [visibleSection]);

    // this is added for redirect to edit mode of payment method while redirecting to all dependent screen

    useEffect(() => {
        if (history.location?.state?.fromSubscriptionScreen) {
            setVisibleSection("Subscription");
            history.replace({
                pathname: history.location.pathname,
                state: {}
            });
        } else if (history.location?.state?.fromBillingScreen) {
            setOpenPaymentInEditMode(true);
            setVisibleSection("PaymentMethod");
            history.replace({
                pathname: history.location.pathname,
                state: {}
            });
        }
    }, [history]);

    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading])

    useEffect(() => {
        const minQty = Math.max(1, props.activeDependentCount || 0);
        if (props.userSubscription?.price_details?.quantity) {
            setSubscriptionQuantity(Math.max(minQty, props.userSubscription.price_details.quantity));
        } else {
            setSubscriptionQuantity(minQty);
        }
    }, [props.userSubscription, props.activeDependentCount]);

    const cancelSubscription = async () => {
        setPopUpType(A12Y_CONST.TEXT.REMOVE_SUBSCRIPTION)
        setIsPopUp2(true);
        await setSubscriptionMsg(A12Y_CONST.TEXT.ARE_YOU_SURE_YOU)
    }

    const handleUnSubscribe = async () => {
        setIsPopUp2(false);
        await props.onCancel();
    }

    const hidePopup2 = () => {
        setIsPopUp2(false);
    }

    const handleJoinClick = () => {
        setIsJoinPopup(true);
    };

    const handleJoinConfirm = () => {
        setIsJoinPopup(false);
        setOpenPaymentInEditMode(true);
        setVisibleSection("PaymentMethod");
    };

    const handleJoinCancel = () => {
        setIsJoinPopup(false);
    };

    const handleRejoinClick = () => {
        const paymentMethod = props?.userSubscription?.payment_method?.is_valid;
        if (paymentMethod) {
            setIsRejoinPopUp(true);
        } else {
            handleJoinClick();
        }
    };

    const handleConfirmRejoin = () => {
        setIsRejoinPopUp(false);
        if (props.onUpdatePayment) {
            props.onUpdatePayment({ qty: Math.max(1, props.activeDependentCount || 0), isRejoin: true });
        }
    };

    useEffect(() => {
        if (props?.userInfo?.address) delete props.userInfo.address['country_code']
        if (props.userInfo.phones !== null && props.userInfo?.phones?.length > 0 && props.userInfo.phones[0].type !== "" && props.userInfo.phones[0].number.length > 1) {
            const mobileNum = parsePhoneNumber('+' + props.userInfo.phones[0].number);
            const mobileNumberFormating = '+1 ' + mobileNum.formatNational()
            setMobileNumberFormat(mobileNumberFormating)
        }
        if (props.userInfo.phones !== null && props.userInfo?.phones?.length > 0 && props.userInfo.phones[1].type !== "" && props.userInfo.phones[1].number.length > 1) {
            const alternateNum = parsePhoneNumber('+' + props.userInfo.phones[1].number);
            const altNumberFormating = '+1 ' + alternateNum.formatNational()
            setAlternateNumberFormat(altNumberFormating)
        }
    }, [props.userInfo])


    const goToAdminDocumentInvoice = () => {
        props.goToDocumnetInvoice()
        history.push(A12Y_CONST.ROUTE.ADMIN_DOCUMENTS);
    }

    const handlePaymentSubmit = async () => {
        if (!stripe || !elements) return;
        setLoading(true);
        const card = elements.getElement(CardNumberElement);
        const payload = await stripe.createPaymentMethod({
            type: 'card',
            card
        });

        if (payload.error) {
            setCardErrorMsg(payload.error.message);
            setLoading(false);
        } else {
            let obj = { payMethod: payload.paymentMethod, editMode: true, qty: subscriptionQuantity }
            await props.onUpdatePayment(obj);
            setLoading(false);
        }
    }

    const planPrice = props.userSubscription?.price_details?.plan_amount || 0;
    const billingPeriod = props.userSubscription?.price_details?.plan_interval_display || '';
    const renewalDate = props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date;
    const formattedRenewalDate = renewalDate ? moment(new Date(renewalDate)).format("MMMM DD, YYYY") : '';


    const renderSubscriptionDetails = (showEdit = false) => {
        return (
            <div className="generalInfoMain dependentProfileMainViewBox fullWidth marginTop30">
                <div className="dependentAddressTitle dependentAddressTitle textStyle positionRelative">
                    <h3 className='df aic'>{A12Y_CONST.TAB_TEXT.SUBSCRIPTION}
                        {/* {showEdit && !props.userSubscription?.trial_period && props.userSubscription?.subscription_details?.subscription_status === A12Y_CONST.TEXT.ACTIVE_UPPER && props?.dependent?.access?.can_update &&
                            <Tooltip color={'#112e53'} placement="right" style={{ borderRadius: '4px', width: '160px', maxWidth: '160px' }} title={<><span className='cursorPointer' style={{ fontSize: '14px', color: 'white', lineHeight: '21px', padding: '5px', fontWeight: 400 }}>You can cancel this subscription by clicking here <a onClick={cancelSubscription} className={'cursorPointer'} style={{ color: '#2D6CB2', display: 'inline-block' }}>Unsubscribe</a></span></>}>
                                <span className='df aic marginLeft20'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 18C5.5817 18 2 14.418 2 10C2 5.582 5.5817 2 10 2C14.4183 2 18 5.582 18 10C18 14.418 14.4183 18 10 18ZM0 10C0 15.523 4.4772 20 10 20C15.5228 20 20 15.523 20 10C20 4.477 15.5228 0 10 0C4.4772 0 0 4.477 0 10Z" fill="#71767A" />
                                        <path d="M10 8C9.4477 8 9 8.448 9 9V15C9 15.552 9.4477 16 10 16C10.5523 16 11 15.552 11 15V9C11 8.448 10.5523 8 10 8Z" fill="#71767A" />
                                        <path d="M8.5 5.5C8.5 6.328 9.1716 7 10 7C10.8284 7 11.5 6.328 11.5 5.5C11.5 4.672 10.8284 4 10 4C9.1716 4 8.5 4.672 8.5 5.5Z" fill="#71767A" />
                                    </svg>
                                </span>
                            </Tooltip>
                        } */}
                    </h3>
                </div>
                {props?.dependent?.access?.can_update ?
                    <div className='billWrap invBox fullWidth fcol'>
                        {props.userSubscription?.subscription_details !== null && props.userSubscription?.subscription_details !== undefined && (!props.userSubscription?.trial_period && !props?.userSubscription?.is_trial_expired ) ?

                            <div className="billLeft">
                                <div className='generaInfoRow fullWidth'>
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.SUBSCRIPTION_PLAN}</span>
                                    <span className="geneInfo_value">
                                        ${props.userSubscription?.price_details?.plan_amount} {''} {A12Y_CONST.LABEL.PER_MONTH}
                                        {/* {props.userSubscription?.price_details?.plan_interval_display} */}
                                        </span>
                                </div>
                                <div className='generaInfoRow fullWidth marginTop15'>
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.SUBSCRIPTION_STATUS}</span>
                                    <span className="geneInfo_value">{props.userSubscription?.cancel_at_period_end ? A12Y_CONST.LABEL.CANCELLED : props.userSubscription?.subscription_details?.subscription_status === A12Y_CONST.LABEL.PAST_DUE ? A12Y_CONST.LABEL.FAILED_PAYMENT : props.userSubscription?.subscription_details?.subscription_status}</span>
                                </div>
                                <div className='generaInfoRow fullWidth marginTop15'>
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.START_DATE}</span>
                                    <span className="geneInfo_value">{(props.userSubscription?.start_date || props.userSubscription?.subscription_details?.start_date) ? moment(new Date(props.userSubscription?.start_date || props.userSubscription?.subscription_details?.start_date)).format("MM/DD/YYYY") : null}</span>
                                </div>
                                {(props.userSubscription?.status === "canceled" || props.userSubscription?.subscription_details?.subscription_status === "CANCELLED" || props.userSubscription?.cancel_at_period_end) ?
                                    <div className='generaInfoRow fullWidth marginTop15'>
                                        <span className="geneInfo_label">{A12Y_CONST.LABEL.EXPIRATION_DATE}</span>
                                        <span className="geneInfo_value">{(props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date) ? moment(new Date(props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date)).format("MM/DD/YYYY") : null}</span>
                                    </div> :
                                    <div className='generaInfoRow fullWidth marginTop15'>
                                        <span className="geneInfo_label">{A12Y_CONST.LABEL.RENEWAL_DATE}</span>
                                        <span className="geneInfo_value">{(props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date) ? moment(new Date(props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date)).format("MM/DD/YYYY") : null}</span>
                                    </div>
                                }
                                <div className='generaInfoRow fullWidth marginTop15'>
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.RENEWAL_PRICE}</span>
                                    {console.log('========= sub=', props.userSubscription)}
                                    <span className="geneInfo_value">${props.userSubscription?.price_details?.renewal_amount?.toFixed(2)} {props.userSubscription?.price_details?.promo_code ? A12Y_CONST.LABEL.CODE_APPLIED + ' ' + props.userSubscription?.price_details?.promo_code : null}</span>
                                </div>
                                <div className='generaInfoRow fullWidth marginTop15'>
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.QUANTITY}</span>
                                    <span className="geneInfo_value">{props.userSubscription?.price_details?.quantity || 0}</span>
                                </div>
                                <div onClick={goToAdminDocumentInvoice} className='fullWidth marginTop15'>
                                    <span id={A12Y_CONST.BUTTON_ID.VIEW_INVOICE_BUTTON} className='view_invoice_text'>{A12Y_CONST.LABEL.view_invoice_receipts}</span>
                                </div>

                                {(props.userSubscription?.cancel_at_period_end || props.userSubscription?.subscription_details?.subscription_status === "CANCELLED" || props.userSubscription?.subscription_details?.subscription_status === "CANCELED" || props.userSubscription?.subscription_details?.subscription_status === "PAST_DUE") && (
                                    <div className="fullWidth marginTop15">
                                        <button id={A12Y_CONST.BUTTON_ID.REJOIN} onClick={handleRejoinClick} className="btn-primary saveButton joinAdvocord plusIcon  textcapitalize"> <span>{A12Y_CONST.BUTTON_TEXT.REJOIN_ADVOCORD}</span></button>
                                    </div>
                                )}
                            </div>
                            :
                            <div className='dependentNoAddressData  fullWidth'>
                                {/* <div className="generaInfoRow fullWidth marginTop15">
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.SUBSCRIPTION_PLAN}</span>
                                    <span className="geneInfo_value">{A12Y_CONST.LABEL.FREE_ACCOUNT_CREATION}</span>
                                </div> */}
                                <div className="generaInfoRow fullWidth marginTop15">
                                    <span className="geneInfo_label">{A12Y_CONST.LABEL.SUBSCRIPTION_STATUS}</span>
                                    <span className="geneInfo_value" style={{ textTransform: 'capitalize' }}>{props.userSubscription?.subscription_details?.subscription_status === "TRIALING" ? "Free Trial" : props.userSubscription?.subscription_details?.subscription_status}</span>
                                </div>
                                {(props?.userSubscription?.end_date || props?.userSubscription?.subscription_details?.end_date) &&
                                    <div className="generaInfoRow fullWidth marginTop15">
                                        <span className="geneInfo_label">{A12Y_CONST.LABEL.EXPIRATION_DATE}</span>
                                        <span className="geneInfo_value">{moment(new Date(props?.userSubscription?.end_date || props?.userSubscription?.subscription_details?.end_date)).format("MM/DD/YYYY")}</span>
                                    </div>}
                                <div className="fullWidth marginTop15">
                                    <button id={A12Y_CONST.BUTTON_ID.JOIN_ADVOCORD} onClick={handleJoinClick} className="btn-primary saveButton joinAdvocord plusIcon textcapitalize"> <span>{A12Y_CONST.BUTTON_TEXT.JOIN_ADVOCORD}</span></button>
                                </div>


                            </div>
                        }
                    </div>
                    :
                    <div className='geneInfo_value marginTop20'>
                        {A12Y_CONST.MESSAGE.YOUR_ACCOUNT_IS_PAID}
                    </div>
                }
            </div>
        )
    }

    const renderPaymentMethodPlanSummary = () => {
        const planName = typeof props.userPlan === 'string'
            ? props.userPlan
            : props.userPlan?.plan_name || props.userSubscription?.plan_name || props.userSubscription?.price_details?.plan_name || A12Y_CONST.LABEL.ESSENTIALS_PLAN;
        const billableDependents = props.userSubscription?.price_details?.quantity || Math.max(1, props.activeDependentCount || 0);
        const baseAmount = props.userSubscription?.price_details?.plan_amount ?? props.userSubscription?.price_details?.renewal_amount ?? 0;
        const displayAmount = props.isPromoCodeApplied && props.discountAmt ? props.discountAmt : baseAmount;
        const billableAmount = (subscriptionQuantity * displayAmount).toFixed(2);
        const discountAmount = props.userSubscription?.price_details?.amount_off;
        const discountPercent = props.userSubscription?.price_details?.percent_off;

        return (
            <div className="paymentSummaryCard fullWidth marginBottom20">
                <div className="paymentSummaryCardHeader df aic jcsb">
                    {/* <div className="paymentSummaryCardPlan">
                        <span className="paymentSummaryCardLabel">Plan summary</span>
                        <span className="paymentSummaryCardTitle">{planName}</span>
                    </div> */}
                    <div className="paymentSummaryCardPrice">
                        <span className="paymentSummaryCardLabel billableAmount">Billable Amount : </span>
                        <span className="paymentSummaryCardAmount">${billableAmount}</span>
                        <span className="paymentSummaryCardInterval">{A12Y_CONST.LABEL.PER_MONTH}</span>
                    </div>
                </div>

                <div className="paymentSummaryCardBody">
                    <div className="paymentSummaryCardItem">
                        <span className="paymentSummaryCardItemLabel">Billable dependents</span>
                        <span className="paymentSummaryCardItemValue">{billableDependents}</span>
                    </div>
                    <div className="paymentSummaryCardItem">
                        <span className="paymentSummaryCardItemLabel">Monthly</span>
                        <span className="paymentSummaryCardItemValue">${displayAmount.toFixed(2)}</span>
                    </div>

                    {(discountAmount || discountPercent) && (
                        <div className="paymentSummaryCardItem paymentSummaryCardDiscountItem">
                            <span className="paymentSummaryCardItemLabel">Discount</span>
                            <span className="paymentSummaryCardItemValue paymentSummaryCardDiscountValue">
                                {discountAmount ? `($${discountAmount.toFixed(2)})` : ''}
                                {discountAmount && discountPercent ? ' | ' : ''}
                                {discountPercent ? `${discountPercent}% Discount` : ''}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const renderBillingStylePlanDetails = () => {
        return (
            <div className="df fcol billingPaddingBottomNone fullWidth subscriptionTabColumm">
                
                <div className="dependentAddressTitle dependentAddressTitle textStyle marginBottom30 positionRelative">
                    <h3 className='df aic'><span className='marginRight20'>Subscription Plan</span>
                        {/* <span className='marginLeftAuto df aic'>
                            {!props.userSubscription?.cancel_at_period_end && !props.userSubscription?.trial_period && props.userSubscription?.subscription_details?.subscription_status === A12Y_CONST.TEXT.ACTIVE_UPPER && props?.dependent?.access?.can_update &&
                                <Tooltip color={'#112e53'} placement="right" style={{ borderRadius: '4px', width: '160px', maxWidth: '160px' }} title={<><span className='cursorPointer' style={{ fontSize: '14px', color: 'white', lineHeight: '21px', padding: '5px', fontWeight: 400 }}>You can cancel this subscription by clicking here <a onClick={cancelSubscription} className={'cursorPointer'} style={{ color: '#2D6CB2', display: 'inline-block' }}>Unsubscribe</a></span></>}>
                                    <span className='df aic'>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 18C5.5817 18 2 14.418 2 10C2 5.582 5.5817 2 10 2C14.4183 2 18 5.582 18 10C18 14.418 14.4183 18 10 18ZM0 10C0 15.523 4.4772 20 10 20C15.5228 20 20 15.523 20 10C20 4.477 15.5228 0 10 0C4.4772 0 0 4.477 0 10Z" fill="#71767A" />
                                            <path d="M10 8C9.4477 8 9 8.448 9 9V15C9 15.552 9.4477 16 10 16C10.5523 16 11 15.552 11 15V9C11 8.448 10.5523 8 10 8Z" fill="#71767A" />
                                            <path d="M8.5 5.5C8.5 6.328 9.1716 7 10 7C10.8284 7 11.5 6.328 11.5 5.5C11.5 4.672 10.8284 4 10 4C9.1716 4 8.5 4.672 8.5 5.5Z" fill="#71767A" />
                                        </svg>
                                    </span>
                                </Tooltip>
                            }
                        </span> */}
                    </h3>
                </div>

                  <div className="marginTopErroMinusPlanDetail">
                    {props.error && props.errorMessage &&
                    <div className='maxWidth600 marginBottom10'>
                        <ErrorMessageComponent errorMessage={props.errorMessage} />
                    </div>
                }
              
                  </div>
                <div className='formRow fullWidth marginTopPlanDetail'>
                    <label>{A12Y_CONST.LABEL.PLAN_DETAILS}</label>
                    {/* <div className='priceListedIs maxWidth300 texAlingCener paddingLeftNone'>
                        {props?.userSubscription?.trial_period || (props?.userSubscription?.subscription_details?.subscription_status === A12Y_CONST.TEXT.CANCELED && !props?.userSubscription?.trial_period && props?.userSubscription?.is_trial_expired) ? '' : A12Y_CONST.LABEL.ESSENTIALS_PLAN}</div> */}
                    <div className="fullWidth billingAmountNew" style={{ textAlign: 'center' }}>
                        {props?.userSubscription?.trial_period && !props?.userSubscription?.is_trial_expired ?
                            <strong className="head24" style={{ color: '#6AA84F' }}>Free Until {moment(props?.userSubscription?.subscription_details?.end_date).format("MM/DD/YYYY")}</strong> :
                            props?.userSubscription?.subscription_details?.subscription_status === A12Y_CONST.TEXT.CANCELED && !props?.userSubscription?.trial_period && props?.userSubscription?.is_trial_expired ?

                                <strong className="head24" style={{ color: '#F04438' }}>EXPIRED - PLEASE SUBSCRIBE</strong>
                                : <strong className="head24"> ${props.isPromoCodeApplied ? props.discountAmt?.toFixed(2) : planPrice?.toFixed(2)} {A12Y_CONST.LABEL.PER_MONTH}</strong>
                        }
                    </div>
                    <div className='fullWidth priceUsCurrencyText marginTop10 paddingLeft10'>
                        Prices are mentioned in US currency and do not include applicable taxes
                    </div>
                </div>

                <div className='formRow fullWidth marginTop30 positionRelative marginTop0px600'>
                    <label className='marginTop20'>Billable Dependents</label>
                    <div className='df aic'>
                        <div className='expenseTypeCol dependentResidencCol hasValue subscriptionQuantityWrapper'>
                            <div className="inputColum24size df aic subscriptionQuantityBox">
                                {subscriptionQuantity}
                            </div>
                        </div>
                        <div className='billableDependentsInfo'>
                            Billable dependents = number of active dependents you manage.  Go to the <span className='dashboardRedirectLink' onClick={() => history.push('/dashboard')}>Dashboard</span> to adjust your active dependents. Changes will be automatically reflected here and adjust your billing amount on a prorated basis.
                        </div>
                    </div>
                </div>

                <div className='formRow fullWidth marginTop20'>
                    <label>Billable Amount</label>
                    <div className='subscriptionTotalAmount newSubTotoalAmount'>
                        ${planPrice
                            ? (subscriptionQuantity * (props.isPromoCodeApplied ? props.discountAmt : planPrice)).toFixed(2)
                            : '0.00'
                        }
                        <span className='subscriptionTotalPer'>{A12Y_CONST.LABEL.PER_MONTH}</span>
                    </div>
                </div>

                {props.userSubscription?.subscription_details !== null && props.userSubscription?.subscription_details !== undefined && (!props.userSubscription?.trial_period && !props?.userSubscription?.is_trial_expired ) ?
                    <>
                        {props.userSubscription?.price_details?.amount_off || props.userSubscription?.price_details?.percent_off ? (
                            <div className='formRow fullWidth marginTop20 paddingTop5' >
                                <label>DISCOUNT</label>
                                <div className="ndcPopup__value newSubTotoalAmount">
                                    <>
                                        {props.userSubscription?.price_details?.amount_off ? `($${props.userSubscription.price_details.amount_off.toFixed(2)})` : ''}
                                        {props.userSubscription?.price_details?.amount_off && props.userSubscription?.price_details?.percent_off ? ' | ' : ''}
                                        {props.userSubscription?.price_details?.percent_off ? `${props.userSubscription.price_details.percent_off}% Discount` : ''}
                                    </>
                                </div>
                            </div>) : null}

                        <div className='formRow fullWidth marginTop20 paddingTop5'>
                            <label>NEXT BILLING DATE</label>
                            <div className="ndcPopup__value newSubTotoalAmount">
                                {(props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date)
                                    ? moment(new Date(props.userSubscription?.renewal_date || props.userSubscription?.subscription_details?.renewal_date)).format("MMMM DD, YYYY")
                                    : 'N/A'
                                }
                            </div>
                        </div>

                        <div className='formRow fullWidth marginTop20 paddingTop5' >
                            <label>NEXT BILLING AMOUNT</label>
                            <div className="ndcPopup__value newSubTotoalAmount">
                                {props.userSubscription?.price_details?.renewal_amount !== undefined
                                    ? `$${props.userSubscription.price_details.renewal_amount.toFixed(2)} ${A12Y_CONST.LABEL.PER_MONTH}`
                                    : 'N/A'
                                }
                            </div>
                        </div>

                        <div className='fullWidth marginTop15 df aic marginTop50' onClick={goToAdminDocumentInvoice}>
                            <span id={A12Y_CONST.BUTTON_ID.VIEW_INVOICE_BUTTON} className='view_invoice_text'>{A12Y_CONST.LABEL.view_invoice_receipts}</span>
                        </div>

                        <div className='fullWidth marginTop10'>
                            <div className='fullWidth'>
                                <span className="anyQuestion">Any questions? Check out our <span><a
                                    id={A12Y_CONST.BUTTON_ID.FAQ_TEXT}
                                    href={A12Y_CONST.TEXT.ADVOCORT_PRICING_URL} rel="noreferrer"
                                    target='_blank' style={{ color: "#0466c8" }}>FAQ's here</a></span>.</span>
                            </div>
                        </div>
                        {(!props.userSubscription?.cancel_at_period_end && !props.userSubscription?.trial_period && props.userSubscription?.subscription_details?.subscription_status === A12Y_CONST.TEXT.ACTIVE_UPPER && props?.dependent?.access?.can_update) && (

                            <div className='fullWidth marginTop15 df aic'>
                                <span className='cancel_subscription_text'
                                    onClick={() => cancelSubscription()}
                                    id={A12Y_CONST.BUTTON_ID.CANCEL_SUBSCRIPTION}
                                >
                                    Cancel Subscription
                                </span>
                            </div>
                        )}
                    </>
                    :
                    <div className="fullWidth marginTop30">
                        <button id={A12Y_CONST.BUTTON_ID.JOIN_ADVOCORD} onClick={handleJoinClick} className="btn-primary saveButton joinAdvocord plusIcon textcapitalize"> <span>{A12Y_CONST.BUTTON_TEXT.JOIN_ADVOCORD}</span></button>
                    </div>
                }
            </div>

        )
    }

    return (
        <div className="titleRow margignTop768_13 margignBottom768_10 ViewExpenseMain myAccountViewMain myAccountViewMainNew addExpensesWrap settingProfileMyAccount">
            {loading ?
                <LoaderFullScreenComponent />
                :
                null
            }
            <div className='titleNameAndTabHeader' id='TitleNameAndTabHeader'>
                <h2 className='titleWithSidebar marginBottom25'>
                    <span>{props.userInfo?.first_name ? `${props.userInfo.first_name.trim()}'s ${A12Y_CONST.TEXT.ADMIN} Account` : A12Y_CONST.TEXT.TITLE_MY_ACCOUNT}</span>
                </h2>
                <TabScrollWrapper>
                    <div className="dependentTabRow">
                        <div
                            className={`width25 width50Percent768 dependentTab texAlingCener ${visibleSection === "Overview" ? "activeDependentTab" : ""}`}
                            onClick={() => setVisibleSection("Overview")}
                        >
                            <span>{A12Y_CONST.TAB_TEXT.OVERVIEW}</span>
                        </div>
                        {(Object.keys(props?.dependent || {}).length === 0 || props?.dependent?.access?.can_update) ?
                            <>
                                <div
                                    className={`width25 width50Percent768 dependentTab texAlingCener ${visibleSection === "Subscription" ? "activeDependentTab" : ""}`}
                                    onClick={() => setVisibleSection("Subscription")}
                                >
                                    <span>{A12Y_CONST.TAB_TEXT.SUBSCRIPTION}</span>
                                </div>
                                <div
                                    className={`width25 width50Percent768 dependentTab texAlingCener ${visibleSection === "PaymentMethod" ? "activeDependentTab" : ""}`}
                                    onClick={() => setVisibleSection("PaymentMethod")}
                                >
                                    <span>{A12Y_CONST.TAB_TEXT.PAYMENT_METHOD}</span>
                                </div>
                                <div
                                    className={`width25 width50Percent768 dependentTab texAlingCener ${visibleSection === "DependentChanges" ? "activeDependentTab" : ""}`}
                                    onClick={() => setVisibleSection("DependentChanges")}
                                >
                                    <span>{A12Y_CONST.TAB_TEXT.DEPENDENT_CHANGES}</span>
                                </div>
                            </>
                            : null}
                    </div>
                </TabScrollWrapper>
            </div>

            <div className='dependentTabContainer borderTransparent fullWidth'>
                {props.showPopup && (
                    <div className='popTop'>
                        <div className='popContainer popMaxWidth'>
                            <div className='popMaster'>
                                <div className="popUpMainBg fullWidth">
                                    <div className="cancelIcon fullWidth marginTopBottom20">
                                        <div className="successIcon">
                                            <svg width="92" height="96" viewBox="0 0 92 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M25 48.5144L39.25 62.3666L63 35.2644" stroke="#34A0A4" strokeWidth="5" strokeLinecap="round" />
                                                <path d="M84.5 47.7731C84.5 70.0948 67.1661 88.0112 46 88.0112C24.8339 88.0112 7.5 70.0948 7.5 47.7731C7.5 25.4513 24.8339 7.53491 46 7.53491C67.1661 7.53491 84.5 25.4513 84.5 47.7731Z" stroke="#34A0A4" strokeWidth="5" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="areYouText planPurchaseTitle" style={props.isRejoinSuccess ? { textAlign: 'center', fontSize: '32px', fontWeight: 700, color: '#112e53' } : { textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#112e53' }}>
                                        {props.isCancelSuccess ? props.successMessage : (props.isRejoinSuccess ? "Success" : (props.firstTimeSubscription?.first_time_subscription ? A12Y_CONST.LABEL.SUBSCRIPTION_ACTIVATED : (isPaymentEdit ? A12Y_CONST.LABEL.SUCCESSFULLY_UPDATE : "Quantity Updated")))}
                                    </div>
                                    <div className={'maxWidth360 useInfo marginTop10'} style={props.isRejoinSuccess ? { textAlign: 'center', margin: '10px auto 30px', fontSize: '22px', fontWeight: '600', color: '#112e53' } : { textAlign: 'center', margin: '10px auto 30px', fontSize: '16px', color: '#112e53' }}>
                                        {props.isCancelSuccess ? `You will have access until ${formattedRenewalDate}.` : (props.isRejoinSuccess ? "You have rejoined Advocord." : (props.firstTimeSubscription?.first_time_subscription ? A12Y_CONST.LABEL.THANK_YOU_FOR_JOINING_NEW : (isPaymentEdit ? A12Y_CONST.LABEL.YOUR_CREDIT_CARD_INFORMATION : "Your subscription quantity has been successfully updated.")))}
                                    </div>
                                    <div className="fullWidth marginBottom20 df jcc">
                                        <div className="popUpNoButton" style={{ background: '#2D6CB2', color: 'white', cursor: 'pointer', fontWeight: 600 }} onClick={() => { setIsPaymentEdit(false); props.closePopUp && props.closePopUp(); }}>{A12Y_CONST.BUTTON_TEXT.CONTINUE}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {visibleSection === "Overview" && (
                    <div className="dependentTabContainerCol borderTransparent">
                        {props.selectPersontalInfo ?
                            <MyAccountPersonalInformationComponent
                                onSubmit={props.onSubmit}
                                userInfo={props.userInfo}
                                error={props.error}
                                errorMessage={props.errorMessage}
                                message={props.successMessage}
                                loading={props.loading}
                                onCancel={() => props.onEdit(false, false, false)}
                                isClickedOutside={props.isClickedOutside}
                                isDataChanged={props.dataChangeHandler}
                            />
                            : props.selectPassword ?
                                <MyAccountPasswordComponent
                                    userInfo={props.userInfo}
                                    onSubmit={props.handelUpdatePasswordSubmit}
                                    error={props.error}
                                    errorMessage={props.errorMessage}
                                    message={props.successMessage}
                                    loading={props.loading}
                                    onCancel={() => props.onEdit(false, false, false)}
                                    isDataChanged={props.dataChangeHandler}
                                    resetFields={props.resetFields}
                                />
                                :
                                <>
                                    <div className="generalInfoMain dependentProfileMainViewBox fullWidth">
                                        <h3 className='df aic'>{A12Y_CONST.TEXT.ADMIN}
                                            <span id={A12Y_CONST.TEXT.EDIT + A12Y_CONST.TEXT.ADMIN} onClick={() => props.onEdit(true, false, false)} className='marginLeft20 cursorPointer'><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.194 0.246632C11.5224 -0.0822106 12.0563 -0.0822106 12.3847 0.246632L15.7531 3.61506C16.0823 3.9439 16.0823 4.47712 15.7531 4.80596L4.80583 15.7533C4.64836 15.9112 4.43363 16 4.21047 16H0.842094C0.377006 16 0 15.623 0 15.1579V11.7895C0 11.5661 0.0887568 11.3519 0.246649 11.194L8.66768 2.77312L11.194 0.246632ZM9.26304 4.55931L1.68419 12.1383V14.3158H3.86184L11.4407 6.73683L9.26304 4.55931ZM12.6314 5.54592L13.967 4.21051L11.7893 2.03299L10.4538 3.3684L12.6314 5.54592Z" fill="#2D6CB2" fillOpacity="0.99" />
                                            </svg>
                                            </span>
                                        </h3>
                                        <div className='invBox df fcol'>
                                            <div className="generaInfoRow fullWidth">
                                                <span className="geneInfo_label">{A12Y_CONST.LABEL.NAME}</span>
                                                <span className="geneInfo_value">{props.userInfo.first_name + ' ' + props.userInfo.last_name}</span>
                                            </div>
                                            {props.userInfo.phones !== null && props.userInfo?.phones?.length > 0 && props.userInfo.phones.map((phone, key) => (
                                                phone.type !== "" && phone.number !== '' ?
                                                    <div key={key} className="generaInfoRow fullWidth marginTop15">
                                                        <span className="geneInfo_label">{phone.type !== null && phone.type === 'office' ? A12Y_CONST.LABEL.OFFICE : phone.type === 'home' ? A12Y_CONST.LABEL.HOME : phone.type === 'mobile' ? A12Y_CONST.LABEL.MOBILE : A12Y_CONST.LABEL.OTHER}</span>
                                                        <span className="geneInfo_value">{key === 0 ? mobileNumberFormat : alternateNumberFormat}</span>
                                                    </div>
                                                    : null
                                            ))}
                                            <div className="generaInfoRow fullWidth marginTop15">
                                                <span className="geneInfo_label">{A12Y_CONST.LABEL.ADDRESS}</span>
                                                <span className="geneInfo_value">{props.userInfo.address && Object.values(props.userInfo.address).filter(ad => ad !== '').join(', ')}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="generalInfoMain dependentProfileMainViewBox fullWidth marginTop30">
                                        <h3 className='df aic'>{A12Y_CONST.TEXT.SIGN_IN_SECURITY}
                                            {!props.userInfo.is_google_user ?
                                                <span id={A12Y_CONST.TEXT.EDIT + A12Y_CONST.BUTTON_ID.SIGN_IN_SECURITY} onClick={() => props.onEdit(false, true, false)}
                                                    className='marginLeft20 cursorPointer'>
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11.194 0.246632C11.5224 -0.0822106 12.0563 -0.0822106 12.3847 0.246632L15.7531 3.61506C16.0823 3.9439 16.0823 4.47712 15.7531 4.80596L4.80583 15.7533C4.64836 15.9112 4.43363 16 4.21047 16H0.842094C0.377006 16 0 15.623 0 15.1579V11.7895C0 11.5661 0.0887568 11.3519 0.246649 11.194L8.66768 2.77312L11.194 0.246632ZM9.26304 4.55931L1.68419 12.1383V14.3158H3.86184L11.4407 6.73683L9.26304 4.55931ZM12.6314 5.54592L13.967 4.21051L11.7893 2.03299L10.4538 3.3684L12.6314 5.54592Z"
                                                            fill="#2D6CB2" fillOpacity="0.99" />
                                                    </svg>
                                                </span>
                                                :
                                                null
                                            }
                                        </h3>
                                        <div className='invBox df fcol'>
                                            <div className="generaInfoRow fullWidth">
                                                <span className="geneInfo_label">{A12Y_CONST.LABEL.EMAIL}</span>
                                                <span className="geneInfo_value">{props.userInfo.email}</span>
                                            </div>
                                            <div className="generaInfoRow fullWidth marginTop15">
                                                <span className="geneInfo_label">{A12Y_CONST.LABEL.PASSWORD}</span>
                                                <span className="geneInfo_value">{A12Y_CONST.TEXT.PASSWORD_ASTRIC}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {renderSubscriptionDetails()}
                                </>
                        }
                    </div>
                )}

                {visibleSection === "Subscription" && (
                    <div className="dependentTabContainerCol billingForm borderTransparent">
                        <div className="generalInfoMain dependentProfileMainViewBox fullWidth">
                            {props?.dependent?.access?.can_update ?
                                renderBillingStylePlanDetails()
                                :
                                <div className='geneInfo_value' style={{ fontSize: '18px', color: '#112e53' }}>
                                    {A12Y_CONST.MESSAGE.YOUR_ACCOUNT_IS_PAID}
                                </div>
                            }
                        </div>
                    </div>
                )}

                {visibleSection === "PaymentMethod" && (
                    <div className="dependentTabContainerCol billingForm">
                        <div className="generalInfoMain dependentProfileMainViewBox fullWidth">
                            {props?.dependent?.access?.can_update ?
                                <div className='billWrap fullWidth fcol'>

                                    {isPaymentEdit ? (

                                        <div className="fullWidth">
                                            <h2 className="paymentEditTitle">Enter your payment method</h2>
                                            <p className="paymentEditSubtitle" >
                                                Please enter your credit card information. This information will be the active card on file and billed based on your monthly subscription. You may change it at any time.                                            </p>

                                            {renderPaymentMethodPlanSummary()}

                                            <div className='formRow cardRow fullWidth marginTop30'>
                                                <label>CARD NUMBER</label>
                                                <div className="fullWidth borderBottom">
                                                    <div className={`fullWidth`}>
                                                        <CardNumberElement
                                                            options={{
                                                                iconStyle: "solid",
                                                                showIcon: true,
                                                                style: { base: window.outerWidth > 768 ? { fontWeight: 400, fontSize: '24px', color: '#112e53' } : { fontWeight: 400, fontSize: '16px', color: '#112e53' } },
                                                            }}
                                                            onChange={(e) => {
                                                                setCardErrorMsg(e.error ? e.error.message : '');
                                                                setIsNumberComplete(e.complete);
                                                            }}
                                                        />
                                                    </div>
                                                    {cardErrorMsg && <div className='errorRelativeRow'><p className='errorMessage'>{cardErrorMsg}</p></div>}
                                                </div>
                                            </div>

                                            <div className="formRow fullWidth marginTop30 payRow">
                                                <div className="width50 paddingRight16 positionRelative">
                                                    <label>EXPIRES</label>
                                                    <div className="fullWidth borderBottom">
                                                        <CardExpiryElement
                                                            options={{ style: { base: window.outerWidth > 768 ? { fontWeight: 400, fontSize: '24px', color: '#112e53' } : { fontWeight: 400, fontSize: '16px', color: '#112e53' } } }}
                                                            onChange={(e) => {
                                                                setExpiryErrorMsg(e.error ? e.error.message : '');
                                                                setIsExpiryComplete(e.complete);
                                                            }}
                                                        />
                                                        {expiryErrorMsg && <div className='errorRelativeRow'><p className='errorMessage'>{expiryErrorMsg}</p></div>}
                                                    </div>
                                                </div>
                                                <div className="width50 paddingleft16 positionRelative paidTo">
                                                    <label className='minWidht190 textAlignRight paddingRight16'>CVC</label>
                                                    <div className="fullWidth borderBottom">
                                                        <CardCvcElement
                                                            options={{ style: { base: window.outerWidth > 768 ? { fontWeight: 400, fontSize: '24px', color: '#112e53' } : { fontWeight: 400, fontSize: '16px', color: '#112e53' } } }}
                                                            onChange={(e) => {
                                                                setCvcErrorMsg(e.error ? e.error.message : '');
                                                                setIsCVCComplete(e.complete);
                                                            }}
                                                        />
                                                        {cvcErrorMsg && <div className='errorRelativeRow'><p className='errorMessage'>{cvcErrorMsg}</p></div>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='formRow fullWidth promoCodeBoxBilling payRow marginTop40'>
                                                <div className='fullWidth width50 maxWidth600 promoCode'>
                                                    <label>{A12Y_CONST.LABEL.PROMO_CODE}</label>
                                                    <div className="fullWidth marginBottom20">
                                                        <div className="fullWidth promoCodeFormRow">
                                                            <div className='fullWidth'>
                                                                <input
                                                                    type="text"
                                                                    value={promoCodeValue}
                                                                    onChange={(e) => setPromoCodeValue(e.target.value)}
                                                                    className="inputColum24size"
                                                                    placeholder='&nbsp;'
                                                                />
                                                                <div className='loaderSpinner'>
                                                                    {props.loading ?
                                                                        <div className='promoCodeButton' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            <Loading />
                                                                        </div>
                                                                        :
                                                                        <input
                                                                            id={A12Y_CONST.BUTTON_ID.PROMOCODE_APPLY_BUTTON}
                                                                            onClick={() => props.applyPromoCode && props.applyPromoCode(promoCodeValue)}
                                                                            className={promoCodeValue.length === 0 ? "saveButtonDisable promoCodeButton" : 'promoCodeButton saveButton'}
                                                                            disabled={promoCodeValue.length === 0}
                                                                            type="button"
                                                                            value={A12Y_CONST.BUTTON_TEXT.APPLY}
                                                                        />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {props.isPromoCodeApplied ?
                                                            <div className={`fullWidth promoCodeMain onlyPromoScreen marginTop20 ${props.isPromoCodeApplied ? 'greenBorder' : ''}`}>
                                                                <div className="fullWidth positionRelative">
                                                                    <div className='referralText'>
                                                                        <span>{A12Y_CONST.TEXT.SPECIAL_CODE} {promoCodeValue}</span>
                                                                        <span>{props.promocodeMessage} {props.promocodeInAmount ? A12Y_CONST.TEXT.DOLLOR_SYMBOL : ''}{props.couponAmount}{props.promocodeInAmount ? '' : A12Y_CONST.TEXT.percent_SYMBOL} {A12Y_CONST.LABEL.A_MONTH}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <p className="marginTop10" style={{ fontSize: '14px', color: '#71767A' }}>Please note, this promo code will be added to next months payment.</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="fullWidth textAlignRight marginTop30 marginBottom30" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                <div className='widthAuto'>
                                                    <input
                                                        className='cancelButton1'
                                                        type="button"
                                                        onClick={() => setIsPaymentEdit(false)}
                                                        value={A12Y_CONST.BUTTON_TEXT.CANCEL}
                                                    />
                                                </div>
                                                <div className='widthAuto marginButton buttonRightMargin'>
                                                    <div className='loaderSpinner'>
                                                        {props.loading && (isNumberComplete && isExpiryComplete && isCVCComplete) ? <Loading /> : null}
                                                        <input
                                                            className={!(isNumberComplete && isExpiryComplete && isCVCComplete) ? "saveButtonDisable" : 'saveButton'}
                                                            disabled={!(isNumberComplete && isExpiryComplete && isCVCComplete)}
                                                            type="button"
                                                            onClick={handlePaymentSubmit}
                                                            value={A12Y_CONST.BUTTON_TEXT.SAVE}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="dependentAddressTitle dependentAddressTitle textStyle marginBottom20 positionRelative">
                                                <h3 className='df aic'>Card on file
                                                    <span onClick={() => setIsPaymentEdit(true)} className='marginLeft20 cursorPointer'>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.194 0.246632C11.5224 -0.0822106 12.0563 -0.0822106 12.3847 0.246632L15.7531 3.61506C16.0823 3.9439 16.0823 4.47712 15.7531 4.80596L4.80583 15.7533C4.64836 15.9112 4.43363 16 4.21047 16H0.842094C0.377006 16 0 15.623 0 15.1579V11.7895C0 11.5661 0.0887568 11.3519 0.246649 11.194L8.66768 2.77312L11.194 0.246632ZM9.26304 4.55931L1.68419 12.1383V14.3158H3.86184L11.4407 6.73683L9.26304 4.55931ZM12.6314 5.54592L13.967 4.21051L11.7893 2.03299L10.4538 3.3684L12.6314 5.54592Z" fill="#2D6CB2" fillOpacity="0.99" />
                                                        </svg>
                                                    </span>
                                                </h3>
                                            </div>
                                            {props.userSubscription?.payment_method?.card_last4 ?
                                                <div className="billRight marginTop20" id={A12Y_CONST.BUTTON_ID.ACTIVE_CARD_IMAGE}>
                                                    <Cards
                                                        name={""}
                                                        preview={true}
                                                        issuer={props?.userSubscription?.paymentMethod?.card_type}
                                                        number={["dinersclub", "amex"].indexOf(props?.userSubscription?.payment_method?.card_type) !== -1 ? "***********" + props.userSubscription?.payment_method?.card_last4 : "************" + props.userSubscription?.payment_method?.card_last4}
                                                        placeholders={{ name: "***" }}
                                                        cvc={"***"}
                                                        expiry={(props?.userSubscription?.payment_method?.card_expiration_month < 10 ? "0" + props.userSubscription?.payment_method?.card_expiration_month.toString() : "" + props.userSubscription?.payment_method?.card_expiration_month) + props.userSubscription?.payment_method?.card_expiration_year}
                                                    />
                                                </div>
                                                :
                                                <div className='geneInfo_value' style={{ fontSize: '18px', color: '#112e53' }}>
                                                    {A12Y_CONST.TEXT.NO_PAYMENT_METHOD}
                                                </div>
                                            }
                                        </>
                                    )}
                                </div>
                                :
                                <div className='geneInfo_value' style={{ fontSize: '18px', color: '#112e53' }}>
                                    {A12Y_CONST.MESSAGE.YOUR_ACCOUNT_IS_PAID}
                                </div>
                            }
                        </div>
                    </div>
                )}

                {visibleSection === "DependentChanges" && (
                    <div className="dependentTabContainerCol">
                        <div className="generalInfoMain dependentProfileMainViewBox fullWidth">
                            <div className='fullWidth textStyle marginBottom30 dependent-changes-desc'>
                                This page lists each change in your account that affects your account subscription (for example, adding a dependent, or making a dependent inactive, or reactivating a dependent). For more information visit our <span><a href={A12Y_CONST.TEXT.ADVOCORT_PRICING_URL} target='_blank' rel="noreferrer" className="dependent-changes-desc-link">Frequently Asked Questions</a></span>.
                            </div>

                            {(() => {
                                const allDependents = props.dependentList || [];
                                const totalCount = allDependents.length;
                                const activeCount = allDependents.filter(d => (d.obj?.status ?? d.status) === 0).length;
                                const inactiveCount = totalCount - activeCount;

                                return (
                                    <div style={{ display: 'flex', gap: '12px', marginBottom: '24px', flexWrap: 'nowrap', width: '100%' }}>
                                        <div style={{ flex: '1 1 0', minWidth: 0, background: '#ffffff', borderRadius: '8px', border: '1px solid rgba(17, 46, 83, 0.1)', borderTop: '4px solid #2d6cb2', padding: '14px 10px', textAlign: 'center', boxSizing: 'border-box' }}>
                                            <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#71767A', marginBottom: '8px', lineHeight: 1.4 }}>Total<br />Dependents</div>
                                            <div style={{ fontSize: '28px', fontWeight: 700, color: '#2d6cb2', lineHeight: 1 }}>{totalCount}</div>
                                        </div>
                                        <div style={{ flex: '1 1 0', minWidth: 0, background: '#ffffff', borderRadius: '8px', border: '1px solid rgba(106, 168, 79, 0.2)', borderTop: '4px solid #6AA84F', padding: '14px 10px', textAlign: 'center', boxSizing: 'border-box' }}>
                                            <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#71767A', marginBottom: '8px', lineHeight: 1.4 }}>Active<br />Dependents</div>
                                            <div style={{ fontSize: '28px', fontWeight: 700, color: '#6AA84F', lineHeight: 1 }}>{activeCount}</div>
                                        </div>
                                        <div style={{ flex: '1 1 0', minWidth: 0, background: '#ffffff', borderRadius: '8px', border: '1px solid rgba(242, 169, 80, 0.25)', borderTop: '4px solid #f2a950', padding: '14px 10px', textAlign: 'center', boxSizing: 'border-box' }}>
                                            <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#71767A', marginBottom: '8px', lineHeight: 1.4 }}>Inactive<br />Dependents</div>
                                            <div style={{ fontSize: '28px', fontWeight: 700, color: '#c97d20', lineHeight: 1 }}>{inactiveCount}</div>
                                        </div>
                                    </div>
                                );
                            })()}

                            <div className='fullWidth' >
                                {(props.dependentEventLogs && props.dependentEventLogs.length > 0) ? (
                                    props.dependentEventLogs.map((log, index) => {
                                        const actionLabel = log.action === 1
                                            ? 'was added.'
                                            : log.action === 31
                                                ? 'was made inactive.'
                                                : log.action === 32
                                                    ? 'was reactivated.'
                                                    : '';
                                        const fullName = `${log.first_name || ''} ${log.last_name || ''}`.trim();
                                        const actionColor = log.action === 1 ? '#6AA84F' : log.action === 31 ? '#f2a950' : log.action === 32 ? '#2d6cb2' : '#3d4551';
                                        const accentColor = log.action === 1 ? '#6AA84F' : log.action === 31 ? '#f2a950' : log.action === 32 ? '#2d6cb2' : '#71767A';
                                        return (
                                            <div key={index} className='fullWidth df aic dependent-change-log-row' style={{ borderBottom: '1px solid rgba(17, 46, 83, 0.1)', borderLeft: `4px solid ${accentColor}`, background: index % 2 === 0 ? '#faf8f4' : '#ffffff' }}>
                                                <div className='dependent-change-log-date'>
                                                    {log.event_date}
                                                </div>
                                                <div className='df aic dependent-change-log-details'>
                                                    <span className='marginRight10 df aic'>
                                                        {log.profile_pic_url ? (
                                                            <img
                                                                src={log.profile_pic_url}
                                                                alt={fullName}
                                                                style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="16" cy="16" r="16" fill="#A1C4E7" />
                                                                <circle cx="16" cy="16" r="15" stroke="#ffffff" strokeWidth="2" />
                                                                <path d="M22.5 22.5C22.625 22.5 22.75 22.375 22.75 22.25C22.5 20.25 21.5 18.5 20 17.25C18.875 16.375 17.5 15.875 16 15.875C14.5 15.875 13.125 16.375 12 17.25C10.5 18.5 9.5 20.25 9.25 22.25C9.25 22.375 9.375 22.5 9.5 22.5L22.5 22.5Z" fill="#F1F8FF" />
                                                                <circle cx="16" cy="11.5" r="3.75" fill="#F1F8FF" />
                                                            </svg>
                                                        )}
                                                    </span>
                                                    <span className="nameDependentResponsive" style={{ fontWeight: 500 }}>{fullName}</span>&nbsp;<span style={{ color: actionColor, fontWeight: 600 }}>{actionLabel}</span>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className='fullWidth df aic' style={{ padding: '20px', color: '#71767A', fontSize: '16px' }}>
                                        No dependent changes recorded yet.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <PopUpComponent
                popUpStatus={isPopUp2}
                title={A12Y_CONST.TEXT.ARE_YOU_SURE_YOU_WANT_TO_UNSUBSCRIBE}
                message={subscriptionMsg}
                buttonDeleteTxt={A12Y_CONST.BUTTON_TEXT.KEEP_PLAN}
                buttonCancelTxt={A12Y_CONST.BUTTON_TEXT.CANCEL_PLAN}
                hidePopUp={handleUnSubscribe}
                handleDeleteButton={hidePopup2}
                popUpType={popUpType}
            />
            <PopUpRejoinConfirmation
                popUpStatus={isRejoinPopUp}
                subscription={props.userSubscription}
                currentCount={props.activeDependentCount || 0}
                onClose={() => setIsRejoinPopUp(false)}
                onConfirm={handleConfirmRejoin}
            />
            <PopUpComponent
                popUpStatus={isJoinPopup}
                title="Ready to Activate Your Subscription?"
                message="The next step is entering your payment information to activate your subscription. No charges will be made until you review and confirm your billing details."
                buttonDeleteTxt={A12Y_CONST.BUTTON_TEXT.CONTINUE}
                buttonCancelTxt={A12Y_CONST.BUTTON_TEXT.CANCEL}
                hidePopUp={handleJoinCancel}
                handleDeleteButton={handleJoinConfirm}
            />
        </div>
    )
}

export default MyAccountViewComponent